// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChecklistController from "./checklist_controller"
application.register("checklist", ChecklistController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import TextareaAutogrowController from "stimulus-textarea-autogrow"
application.register("textarea-autogrow", TextareaAutogrowController)
